'use client'

import { usePathname } from 'next/navigation'

import ContentHtml from '@/components/home/ContentHtml.jsx'
import { GR_PAGE_BY_PATH } from '@/data/grPages.js'

import article from './GrArticle.module.css'
import styles from './GrDoc.module.css'

/*
 * 烘焙的獨立內容頁 —— 舊 WP 的政策/活動頁搬 React,退 WP 前置。兩種版型:
 *   mode='prose'  網站聲明/隱私權/責任博彩 —— 走共用 ContentHtml + GrArticle 的 .prose(760 容器、金底線標題)。
 *   mode='raw'    娛樂城優惠 —— 原頁手風琴自帶一整套 scoped CSS(命名空間 .tj-rules-v3-container),整塊原樣搬;
 *                 無 Bootstrap JS,抽取時已把 collapse 改成常開(collapse show)供 SEO,這裡再用 .promo 隱藏展開箭頭。
 * 哪一頁由網址比對 grPages.js(static export 一條路由一頁);標題列去「- 淘金娛樂城」站名尾。
 */
const norm = (p) => {
  let s = (p || '/').replace(/\/+$/, '') || '/'
  try {
    s = decodeURIComponent(s)
  } catch {
    // pathname 已是 decoded 形式就維持原樣
  }
  return s.toLowerCase()
}

export default function GrDoc() {
  const p = GR_PAGE_BY_PATH[norm(usePathname())]
  if (!p) return null

  if (p.mode === 'raw') {
    return (
      <main className={styles.page}>
        <div className={styles.inner}>
          <h1 className={styles.h1}>{p.heading}</h1>
          <div className={styles.promo} dangerouslySetInnerHTML={{ __html: p.html }} />
        </div>
      </main>
    )
  }

  return (
    <main className={article.page}>
      <article className={article.inner}>
        <h1 className={article.h1}>{p.heading}</h1>
        <ContentHtml html={p.html} className={article.prose} />
      </article>
    </main>
  )
}
